import {enableProdMode, provideZoneChangeDetection} from '@angular/core';
import {platformBrowser} from '@angular/platform-browser';

import {AppModule} from './app/app.module';
import {environment} from './environments/environment';

declare global {
    interface Window {
        googleMapsApiReady?: Promise<void>;
        initGoogleMapsApi?: () => void;
        rejectGoogleMapsApi?: (error: Error) => void;
    }
}

if (environment.production) {
    enableProdMode();
}

const mapsApiReady = window.googleMapsApiReady || Promise.resolve();

mapsApiReady
    .then(() => platformBrowser().bootstrapModule(AppModule, {
        applicationProviders: [provideZoneChangeDetection()],
    }))
    .catch((err) => console.error(err));
